import { Injectable, isDevMode } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpHelper } from '../helpers/http-helper';
import { AuthenticationService } from './authentication.service';
import { StorageManagerService } from './storage-manager.service';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { SettingsService } from './settings.service';
import { ISubmission } from '../models/submission.model';
import { ICreateSubmissionResponse } from '../models/create-submission-response-model';

@Injectable()
export class ESGSubmissionService {
  httpHelper: HttpHelper;

  constructor(private http: HttpClient, private authService: AuthenticationService, private storageManagerService: StorageManagerService,
    private settingsService: SettingsService) {
    // Define an instance of the http helper class that will be used to create httpHeader for api calls
    this.httpHelper = new HttpHelper(http, authService, storageManagerService);
  }

  getFullNameByEmail(email: string) {
    const settings = this.settingsService.getSettings();
    const action = `ids/v1/User/ByLoginName?loginName=${email}`;
    const headers = this.authService.setHeader();

    return this.http.get(`${settings.CommonApiGatewayUrl}/${action}`, { headers: headers })
      .pipe(map(this.extractData),
        catchError(this.handleErrors));
  }

  createDrugProductSubmission(drugProductSubmission: ISubmission[]) {
    const headers = this.httpHelper.createHttpHeaders();
    const settings = this.settingsService.getSettings();

    const url = `${settings.ApiGatewayUrl}/sub/v1/Submission/CreateDrugProductSubmission`;

    return this.http.post(`${url}`, drugProductSubmission, { headers: headers })
      .pipe(map(this.extractSubmissionResponseData),
        catchError(this.handleErrors));
  }

  private extractData(response: Response) {
    if (response.status < 200 || response.status >= 300) {
      throw new Error('Bad response status: ' + response.status);
    }

    const body = response;
    return body || {};
  }

  private extractSubmissionResponseData(response: ICreateSubmissionResponse) {
    if (response.status !== 0 || response.errors !== null || response.objectCount > 0) {
      throw new Error('Bad response status: ' + response.status);
    }

    const body = response;
    return body || {};
  }

  // Error handling
  private handleErrors(error: any): Observable<any> {
    const GENERIC_ERROR_MSG = 'It looks like something went wrong. Try reloading the page or contacting support if this issue continues.';
    const bDisplayDetailMsg = error && error.error && error.error.isBusinessErrorMessage ? true : !!isDevMode();
    error.error = error && error.error && error.error.message && bDisplayDetailMsg ? error.error.message : GENERIC_ERROR_MSG;

    return throwError(error.error);
  }
}
